import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "../links.js";
export function MarkedLink({ children, href }) {
    return _jsx(Link, { href: href, children: children });
}
